import React from 'react';
import PropTypes from 'prop-types';

import {startContext} from '~/src/utilities/helpers/context';

const AppContext = React.createContext({
    bookmarks: [],
    likes: [],
    ratings: [],
    reactions: []
});

class Context extends React.Component {
    static async getInitialProps() {
        const bookmarks = [];
        const likes = [];
        const ratings = [];
        const reactions = [];

        return {
            bookmarks,
            likes,
            ratings,
            reactions
        };
    }

    setContext = (context) => {
        this.setState({context});
    };

    state = {
        context: this.props.context
    };

    componentDidMount() {
        startContext(this.props.context, this.setContext);
    }

    render() {
        return <AppContext.Provider value={this.state.context}>{this.props.children}</AppContext.Provider>;
    }
}

Context.propTypes = {
    context: PropTypes.shape({
        bookmarks: PropTypes.array,
        likes: PropTypes.array,
        ratings: PropTypes.array,
        reactions: PropTypes.array
    }).isRequired
};

const withContext = (WrappedComponent) => {
    return (props) => <AppContext.Consumer>{(context) => <WrappedComponent {...context} {...props} />}</AppContext.Consumer>;
};

export {Context, withContext};

export default AppContext;
